export const API_URL =
	process.env.NODE_ENV === 'development'
		? 'http://localhost:4000'
		: 'https://web-production-7637.up.railway.app';
